<template>
  <f7-page @page:beforein="autoSave" @page:beforeout="beforeOut">
    <f7-navbar back-link="back">
      <f7-nav-title>
        <navbar-center v-if="currentDraft" :href="`/stores/${this.storeId}/menu-drafts/${currentDraft.variation}/settings`">
          <div slot="title">{{ currentDraft.title }}</div>
          <div slot="subtitle">{{ currentDraft.variation }}</div>
          <div slot="after">
            <font-awesome-icon icon="edit"/>
          </div>
        </navbar-center>
      </f7-nav-title>
      <f7-nav-right>
        <f7-link @click="saveDraft(currentDraft.variation)">
          <font-awesome-icon :icon="['far', 'save']"/>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-progressbar v-if="!currentDraft" infinite color="green"></f7-progressbar>
    <div v-else style="position: absolute; top: 56px; bottom: 0px; width: 100%;">
      <tabs :objects="sortedCategoryObjects" @tabbarClicked="onTabbarClicked">
        <div
          slot="tabbar-after"
          style="padding: 0px 10px; margin: 12px 0px; border: solid 1px #FFFFFF; border-width: 0px 0px 0px 1px; height: 24px; line-height: 24px;">
          <f7-link style="margin: 0px 10px;" :href="`/stores/${storeIdProp}/menu-drafts/${menuDraftVariationProp}/categories`">
            <font-awesome-icon icon="sort" style="color: #FFFFFF;"/>
          </f7-link>
          <f7-link style="margin: 0px 10px;">
            <font-awesome-icon icon="plus" style="color: #FFFFFF;" @click="createCategory" />
          </f7-link>
        </div>
        <template slot="tabbar-objects" slot-scope="props">
          <template v-if="props.object.type !== 'static'">{{ props.object.title }}</template>
        </template>
        <template slot="tab-objects" slot-scope="props">
          <div
            v-if="props.object.type !== 'static'"
            style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; overflow: auto;">
            <f7-list
              v-for="(group, groupIndex) in props.object.groups.map(id => currentDraft.groups[id])"
              :key="`menu-group${group.id}-${groupIndex}`"
              media-list
              sortable
              :sortable-enabled="true"
              @sortable:sort="onItemSort(group.id, $event.detail.from, $event.detail.to)"
              no-hairlines-between
              style="margin: 0px 0px 0px 0px;">
              <div style="height: 48px; line-height: 48px; background-color: rgb(244, 244, 244); color: rgba(0, 0, 0, 0.54); padding: 0px 16px; font-size: 16px; display: flex;">
                <span style="flex: 1 1 auto;" @click="$f7.dialog.prompt('次類別標題', group.title, v => setGroupProperties({ groupId: group.id, properties: { title: v } }))">
                  {{ group.title || '次類別' }}
                </span>
                <f7-button
                  raised
                  fill
                  @click="onDeleteGroup({ categoryId: props.object.id, groupId: group.id, groupTitle: group.title || '次類別' })"
                  style="flex: 0 0 auto; margin: 6px 0px 6px 10px;">
                  <font-awesome-icon icon="trash" /> 刪除
                </f7-button>
              </div>
              <f7-list-item
                v-for="(item, index) in group.items.map(id => currentDraft.items[id])"
                :key="`edit-main-list-group-${index}`"
                :title="item.title"
                :subtitle="item.abbreviation"
                :text="`NT\$${parseFloat(item.price)}`"
                media-item
                @click="showItemActions(props.object.id, props.index, group.id, groupIndex, item.id, index)">
                <img
                  v-if="item.coverImgUrl"
                  :src="ImageUrlBuilder.url64(item.coverImgUrl, storeId)"
                  :srcset="`${ImageUrlBuilder.url128(item.coverImgUrl, storeId)} 2x, ${ImageUrlBuilder.url192(item.coverImgUrl, storeId)} 3x`"
                  style="width: 64px"
                  slot="media">
                <img v-else slot="media" src="@/assets/itemDefault.jpg" alt="預設圖片" style="width: 64px;" />
              </f7-list-item>
              <f7-button fill raised @click="createItem(group.id)" style="margin: 10px 10%;">新增餐點</f7-button>
            </f7-list>
            <f7-button fill raised @click="createGroup(props.object.id)" style="margin: 10px 10%;">新增次類別</f7-button>
          </div>
        </template>
      </tabs>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NavbarCenter from '@/common/components/NavbarCenter'
import Tabs from '@/common/components/Tabs'

export default {
  dependencies: [
    'platformUtils',
    'ImageUrlBuilder',
    'apiStateType'
  ],
  data () {
    return {
      platform: process.env.VUE_APP_PLATFORM,
      showDraft: false
    }
  },
  async created () {
    await this.setStore(this.storeIdProp)
    if (!this.currentDraft || this.currentDraft.variation !== this.menuDraftVariationProp) {
      this.setCurrentDraft(null)
      await this.getMenuDraft(this.menuDraftVariationProp)
    }
  },
  computed: {
    ...mapState('menuDraftModule', [
      'currentDraft',
      'getCurrentDraftState',
      'currentElementPath',
      'updateCurrentDraftState'
    ]),
    ...mapGetters(['storeId']),
    sortedCategoryObjects () {
      return Object.keys(this.currentDraft.categories || {})
        .map(k => (this.currentDraft.categories || {})[k])
        .sort((a, b) => a.categoryOrder - b.categoryOrder)
    }
  },
  watch: {
    getCurrentDraftState ({ type, payload }) {
      if (type === this.apiStateType.error) {
        this.$f7.dialog.alert('失敗', '讀取草稿失敗')
        this.setGetCurrentDraftState(this.apiStateType.idle)
        this.$f7router.back()
      } else if (type === this.apiStateType.ok) {
        this.setGetCurrentDraftState(this.apiStateType.idle)
      }
    },
    updateCurrentDraftState ({ type, payload }) {
      if (type === this.apiStateType.ok) {
        this.$f7.toast.create({
          text: '草稿儲存成功',
          closeTimeout: 2000,
          closeButton: true,
          closeButtonText: '關閉',
          closeButtonColor: 'red'
        }).open()
        this.setUpdateCurrentDraftState(this.apiStateType.idle)
      } else if (type === this.apiStateType.error) {
        this.$f7.toast.create({
          text: '草稿儲存失敗，請重新整理',
          closeTimeout: 2000,
          closeButton: true,
          closeButtonText: '關閉',
          closeButtonColor: 'red'
        }).open()
        this.setGetCurrentDraftState(this.apiStateType.idle)
      }
    }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('menuDraftModule', [
      'setCurrentElementPath',
      'setGetCurrentDraftState',
      'setUpdateCurrentDraftState',
      'getMenuDraft',
      'setCurrentDraft',
      'saveDraft',
      'createCategory',
      'setCategoryProperties',
      'createItem',
      'createGroup',
      'setGroupProperties',
      'deleteGroup'
    ]),
    onTabbarClicked ({ currentIndex, previousIndex }) {
      if (previousIndex === currentIndex) {
        const category = this.sortedCategoryObjects[currentIndex]
        this.$f7.dialog.prompt('類別名稱', category.title, v => this.setCategoryProperties({ id: category.id, properties: { title: v } }))
      }
    },
    onItemSort (groupId, from, to) {
      const items = this.currentDraft.groups[groupId].items.slice()
      items.splice(to, 0, items.splice(from, 1)[0])
      this.setGroupProperties({ groupId, properties: { items } })
    },
    onDeleteGroup ({ categoryId, groupId, groupTitle }) {
      this.$f7.dialog.confirm(`確定要刪除 ${groupTitle} ?`, '刪除次類別', () => {
        this.deleteGroup({ categoryId, groupId })
      })
    },
    autoSave () {
      if (this.currentDraft) {
        this.saveDraft(this.currentDraft.variation)
      }
    },
    beforeOut () {
      this.$f7.dialog.close()
    },
    showItemActions (categoryId, categoryIndex, groupId, groupIndex, itemId, itemIndex) {
      this.setCurrentElementPath([{ id: categoryId, index: categoryIndex }, { id: groupId, index: groupIndex }, { id: itemId, index: itemIndex }])
      this.$f7router.navigate(`/stores/${this.storeId}/menu-drafts/${this.currentDraft.variation}/items/${itemId}/item-actions`)
    }
  },
  components: {
    Tabs,
    NavbarCenter
  }
}
</script>
